import ApiService from "./api.service";
import appConfig from "../helpers/multidomain.helper";
import store from "../store/mainStore";
import { encryptStorage } from '../../src/services/encrypt.service';
import moment from "moment";

class I18nService extends ApiService {
    constructor(){
        super();
        this._selectedLocaleKey = "selected-locale-key";
        this._owSelectedLocalKey = "ow-selected-locale-key";
        this._publicInfoSelectedLocaleKey = "public-info-selected-locale-key"
    }

    geti18nMessages(languageId){
        return this.get(`/api/i18n/language/${languageId}/translations/dictionary`)
    }

    async getAvailableLanguages(forceReload = false){
        const storeLanguages = store.state.i18nStore.availableLanguages;
        if(storeLanguages == null || storeLanguages == undefined || storeLanguages.length === 0 || forceReload){
            const result = await this.get(`/api/i18n/language`)
            if(result.status !== 200){
                throw new Promise.reject(result);
            }
            store.commit("setAvailableLanguages", result.data);
            return result.data;
        }
        return storeLanguages;
    }
    async getLocale(){
        let key = this._selectedLocaleKey

        if(!this.isPublicSessionInfo() && this.isOw()){
            key = this._owSelectedLocalKey;
        }
        else if(this.isPublicSessionInfo() && !this.isOw()){
            key = this._publicInfoSelectedLocaleKey;
        }

        const savedLocale = encryptStorage.getItem(key);
        if(savedLocale){
            return savedLocale
        }
        const navigatorLanguage = this._getNavigatorLanguage();
        const availableLanguages = await this.getAvailableLanguages(true);
        const isNavigatorSupported = this.isLanguageAvailable(navigatorLanguage, [...availableLanguages]);
        const isDomainSupportedLanguage =  this.isLanguageAvailable(appConfig.language.code, [...availableLanguages]);

        if(isDomainSupportedLanguage){
            return availableLanguages.find(lang => lang.code === appConfig.language.code);
        }

        if(isNavigatorSupported){
            return availableLanguages.find(lang => lang.code === navigatorLanguage)
        }

        return this.getDefaultLanguage();
    }


    _getNavigatorLanguage(){
        return navigator.language.split('-')[0]; // np. 'en' z 'en-US'
    }

    async setLocale(languageItem){
        encryptStorage.setItem(this._selectedLocaleKey, languageItem)
        moment.locale(languageItem.code);
        await this.put(`Auth/change-language/${languageItem.id}`);
    }

    async setLocaleByLanguageCodeForOw(languageCode){
        const availableLanguages = await this.getAvailableLanguages();
        const isAvailable = this.isLanguageAvailable(languageCode, [...availableLanguages]);
        const languageItem = isAvailable ? availableLanguages.find(lang => lang.code === languageCode) : this.getDefaultLanguage();
        encryptStorage.setItem(this._owSelectedLocalKey, languageItem)
        return languageItem;
    }

    async setLocaleByLanguageCodeForPublicInfo(languageCode){
        const availableLanguages = await this.getAvailableLanguages();
        const isAvailable = this.isLanguageAvailable(languageCode, [...availableLanguages]);
        const languageItem = isAvailable ? availableLanguages.find(lang => lang.code === languageCode) : this.getDefaultLanguage();
        encryptStorage.setItem(this._publicInfoSelectedLocaleKey, languageItem)
        return languageItem;
    }

    async getTranslationKeys(){
        const result = await this.get(`/api/i18n/translation-key`)
        if(result.status !== 200){
            throw await Promise.reject(result);
        }
        store.state.i18nStore.allTranslationKeys = result.data;
        store.state.i18nStore.paginatedData.totalItems = store.state.i18nStore.allTranslationKeys.length
        return result;
    }

    async addTranslationKeys(data){
        const result = await this.post(`/api/i18n/translation-key`, data)
        if(result.status !== 200){
            throw await Promise.reject(result);
        }
        store.state.i18nStore.allTranslationKeys = result.data;
        store.state.i18nStore.paginatedData.totalItems = store.state.i18nStore.allTranslationKeys.length
        return result;
    }

    async updateTranslationKeys(id, data){
        const result = await this.put(`/api/i18n/translation-key/${id}`, data)
        if(result.status !== 200){
            throw await Promise.reject(result);
        }
        store.state.i18nStore.allTranslationKeys = result.data;
        store.state.i18nStore.paginatedData.totalItems = store.state.i18nStore.allTranslationKeys.length
        return result;
    }

    getTranslationByLanguageId(languageId){
        return this.get(`/api/i18n/language/${languageId}/translations`);
    }

    addTranslationByLanguage(languageId, data){
        return this.post(`/api/i18n/language/${languageId}/translations`, data);
    }

    updateTranslationByLanguage(languageId, translationId, data){
        return this.put(`/api/i18n/language/${languageId}/translations/${translationId}`, data);
    }

    isOw(){
        const fullUrl = window.location.href;
        return fullUrl.includes("/PublicSession/");
    }

    isPublicSessionInfo(){
        const fullUrl = window.location.href;
        return fullUrl.includes("/PublicSessionInfo/");
    }
    getDefaultLanguage(){
        return {id: 1, code: 'pl', culture: 'pl-PL', name: 'Polski'}
    }

    isLanguageAvailable(requestLanguageCode, availableLanguages){
        if(!requestLanguageCode)
            return false;

        if(!availableLanguages)
            return false;

        return availableLanguages.some(lang => lang.code === requestLanguageCode);
    }
}

export default new I18nService;